// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".signup-background .broadly-logo {\n  width: 120px;\n  height: auto;\n  position: absolute;\n  top: 20px;\n  left: 20px;\n}\n@media (max-width: 640px) {\n  .signup-background .broadly-logo {\n    top: 10px;\n    left: 10px;\n  }\n}\nhtml.device-iphone-x .signup-background .broadly-logo {\n  top: constant(safe-area-inset-top);\n  top: env(safe-area-inset-top);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
